import script from "./CancelledList.vue?vue&type=script&lang=ts&setup=true&name=CancelledList"
export * from "./CancelledList.vue?vue&type=script&lang=ts&setup=true&name=CancelledList"

import "./CancelledList.vue?vue&type=style&index=0&id=2efae548&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efae548"]])

export default __exports__